import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSetTitleOnLoad } from 'hooks/useSetTitleOnLoad';
import { useDispatch, useSelector } from 'react-redux';
import { serviceLogoutStart } from 'store/authentication/authenticationAction';
import { useHistory } from 'react-router-dom';
import { postForceLogOutMessage } from 'store/authentication/channels';

const Logout = ({ title }) => {
  const { t } = useTranslation();
  useSetTitleOnLoad(title(t));
  const history = useHistory();
  const dispatch = useDispatch();
  const instanceId = useSelector((s) => s.authentication.instanceId);

  const searchParams = new URLSearchParams(history.location.search);
  const skip = searchParams.get('skip');

  useEffect(() => {
    if (!skip) {
      postForceLogOutMessage(instanceId);
    }
    dispatch(serviceLogoutStart({ skipApi: false }));
    history.replace('/login');
  }, [dispatch, history, instanceId, skip]);

  return null;
};

export default Logout;
